
CustomTC.define('text!modules/chat/htmls/chat.html',[],function () { return '<!-- Display chat section Starts -->\n<div class="tcChatWrapper">\n    <div class="tcChatBox"></div>\n</div>\n<!-- Display chat section Ends -->';});

